var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" transacao-list"},[_c('div',{staticClass:"card5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"card-form"},[_c('h3',[_vm._v("Novo Estabelecimento")]),_c('institution-form')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }